import { Icon } from "./UI/Icon";

export default function PasswordRequirements({ password }) {
  const checks = {
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*()_+\-=\[\]{};:'",.<>\/?\\|]/.test(password),
    length: password.length >= 8
  };

  const getRowClass = (ok) =>
    `flex items-center gap-2 ${ok ? "text-green-600" : "text-black"}`;
  const getIconClass = (ok) =>
    `w-4 h-4 ${ok ? "text-green-600" : "text-red-600"}`;
  const getIcon = (ok) =>
    <Icon name={ok ? 'check' : 'cross'} className={getIconClass(ok)} />;

  return (
    <div>
      <p className="text-sm font-medium text-gray-700 mb-2">La password deve contenere:</p>
      <ul className="text-sm space-y-1">
        <li className={getRowClass(checks.upper)}>
          {getIcon(checks.upper)}
          <span>1 lettera maiuscola (A-Z)</span>
        </li>
        <li className={getRowClass(checks.lower)}>
          {getIcon(checks.lower)}
          <span>1 lettera minuscola (a-z)</span>
        </li>
        <li className={getRowClass(checks.number)}>
          {getIcon(checks.number)}
          <span>1 numero (0-9)</span>
        </li>
        <li className={getRowClass(checks.special)}>
          {getIcon(checks.special)}
          <span>1 carattere speciale (!@#$...)</span>
        </li>
        <li className={getRowClass(checks.length)}>
          {getIcon(checks.length)}
          <span>Almeno 8 caratteri</span>
        </li>
      </ul>
    </div>
  );
}
